// Copyright © 2021 Move Closer
import { AbstractTypeDriver } from './abstract';
import { RelatedType } from '../contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class ContentDriver extends AbstractTypeDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = RelatedType.Content;
    }
    /**
     * @inheritDoc
     */
    resolve(id, record, config, driverResolver) {
        const description = super.resolve(id, record, config, driverResolver);
        const authorDriver = driverResolver(RelatedType.Author);
        const fileDriver = driverResolver(RelatedType.File);
        const labelsDriver = driverResolver(RelatedType.Label);
        let author;
        let coverProperty;
        const labels = [];
        try {
            author = authorDriver.resolve(`${description.author.value}`, record, config, driverResolver);
        }
        catch (e) {
            author = undefined;
        }
        if (typeof description.properties.cover === 'object' && description.properties.cover !== null) {
            coverProperty = { ...description.properties.cover };
            try {
                coverProperty.image = fileDriver.resolve(`${description.properties.cover.image.value}`, record, config);
            }
            catch (e) {
                coverProperty.image = undefined;
            }
        }
        if (Array.isArray(description.properties.labels) && description.properties.labels.length > 0) {
            for (const l of description.properties.labels) {
                try {
                    const label = labelsDriver.resolve(l.value, record, config);
                    labels.push(label);
                }
                catch (e) {
                    console.warn(e);
                }
            }
        }
        return {
            ...description,
            properties: {
                ...description.properties,
                labels: labels,
                cover: coverProperty
            },
            author: author
        };
    }
}
